import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  headFlex: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  banksFlexRow: {
    display: "flex",
    justifyContent: "flex-start",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    width: "40%",
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    margin: "2rem",
    textAlign: "center",
    justifyItems: "center",
    alignContent: "center",
  },
  checkcircle: {
    fontSize: theme.typography.pxToRem(64),
    alignSelf: "center",
    marginBottom: "2rem",
  },
  headerSpace: {
    marginBottom: theme.spacing(2),
  },
  subtitleSpace: {
    margin: theme.spacing(1.5, 0),
  },
  spaceCards: {
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
  borderBox: {
    borderRadius: "4px",
  },
  breakText: {
    wordBreak: "break-all",
  },

  paraHead: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(8),
  },
  list: {
    marginBottom: theme.spacing(8),
    paddingLeft: "20px",
  },
  listItem: {
    fontSize: theme.typography.pxToRem(22),
    padding: 0,
    marginBottom: theme.spacing(2),
    "&::marker": {
      color: theme.palette.info.main,
    },
  },
  cardList: {
    [theme.breakpoints.down("sm")]: {
      width: "400px",
    },
    [theme.breakpoints.only("xs")]: {
      width: "300px",
    },
  },
  conainerLogos: {
    paddingTop: theme.spacing(6),
  },
  apply: {
    padding: theme.spacing(0.7, 3.6),
  },
}));

export default useStyles;
